import React from 'react'

import styled from 'styled-components'
import { DateRangeProps, Wrapper } from './DateRangePicker'
import DateRangePicker from 'react-bootstrap-daterangepicker'
import moment from 'moment'

const CustomWrapper = styled(Wrapper)`
  input {
    width: 233px;
  }
`

export const DateWithTimeRangePicker: React.FC<DateRangeProps> = (
  props
) => {
  const { onFilterApply } = props

  const handleApply = (event, picker) => {
    onFilterApply({
      startDate: picker.startDate.toLocaleString(),
      endDate: picker.endDate.toLocaleString(),
    })
  }
  return (
    <CustomWrapper {...props}>
      <DateRangePicker
        onApply={handleApply}
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        initialSettings={{
          showDropdowns: true,
          timePicker: true,
          startDate: moment().startOf('hour').toDate(),
          endDate: moment().startOf('hour').add(32, 'hour').toDate(),
          locale: {
            format: 'MM/DD/YYYY hh:mm A',
          },
        }}
      >
        <input type="text" />
      </DateRangePicker>
    </CustomWrapper>
  )
}
